import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { UserService } from '../services/user.service';
import { filter, map, take } from 'rxjs/operators';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginGuard implements CanActivate, CanLoad {
  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private storageService: StorageService,
    private router: Router) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(): Observable<boolean> {
    return this.loginService.isAuthenticated.pipe(
      filter(val => val !== null), // Filter out initial Behaviour subject value
      take(1), // Otherwise the Observable doesn't complete!
      map(isAuthenticated => {
        if (isAuthenticated) {
          // Already logged in, proceed
          console.log('Found previous token, automatic login');
          this.userService.getUser();
          this.storageService.get('isRoutedFromACP').then(result => {
            if (result === true) {
              this.storageService.removeAll();
              window.close();
            }
            else {
              this.router.navigateByUrl('/home', { replaceUrl: true });
            }
          });
        } else {
          // Route to login page
          return true;
        }
      })
    );
  }
}
